import { Injectable } from '@angular/core';

import { registerLocale } from 'echarts/core';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class ChartMomentConfigService {
  constructor() {
    const momentLocale = moment.localeData(moment.locale());

    registerLocale(moment.locale(), <any>{
      time: {
        month: momentLocale.months(),
        monthAbbr: momentLocale.monthsShort(),
        dayOfWeek: momentLocale.weekdays(),
        dayOfWeekAbbr: momentLocale.weekdaysShort(),
      },
    });
  }

  // empty method to avoid unused injection warning in component
  // constructor of this service is used to register locale and it has to be done once before any chart is created
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public init() {}
}
